angular.module('storefrontApp')
    .component('vcCheckoutShippingMethods', {
        templateUrl: 'themes/assets/js/checkout/checkout-shippingMethods.tpl.liquid',
        bindings: {
            shipment: '=',
            getAvailShippingMethods: '&',
            onSelectShippingMethod: '&',
            validationContainer: '=',
        },
        controller: ['$scope', function ($scope) {
            const ctrl = this;

            clear();

            this.$onInit = function () {
                ctrl.loading = true;

                if (ctrl.validationContainer) {
                    ctrl.validationContainer.addComponent(this);
                }
            };

            this.$onDestroy = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.removeComponent(this);
                }
            };

            function getMethodId(method) {
                let retVal = method.shipmentMethodCode;

                if (method.optionName) {
                    retVal += ':' + method.optionName;
                }

                return retVal;
            }

            ctrl.selectMethod = function (method) {
                ctrl.selectedMethod = method;
                ctrl.onSelectShippingMethod({
                    shippingMethod: method,
                });
            };

            ctrl.validate = function () {
                ctrl.form.$setSubmitted();
                return ctrl.form.$valid;
            };

            function getAvailShippingMethods() {
                ctrl.getAvailShippingMethods(ctrl.shipment)
                    .then(function (availMethods) {
                        ctrl.availShippingMethods = availMethods;
                        _.each(ctrl.availShippingMethods, function (x) {
                            x.id = getMethodId(x);
                            x.displayName = x.optionName.split('|')[0];
                        });
                        ctrl.selectedMethod = _.find(ctrl.availShippingMethods, function (x) {
                            return ctrl.shipment.shipmentMethodCode === x.shipmentMethodCode
                                && ctrl.shipment.shipmentMethodOption === x.optionName;
                        });
                        ctrl.loading = false;
                    });
            }

            function clear() {
                ctrl.availShippingMethods = [];
                ctrl.selectedMethod = {};
            }

            $scope.$on('selectedShipmentAddressChanged', function (event, data) {
                if (!data.isValid) {
                    clear();
                } else {
                    getAvailShippingMethods();
                }
            });
        }],
    });
